
import { Link } from 'react-router-dom';

export default function GoalSettingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-600 via-emerald-600 to-teal-600 text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <Link to="/motivation" className="inline-flex items-center text-white/80 hover:text-white mb-6 transition-colors">
              <i className="ri-arrow-left-line mr-2"></i>
              動機付け一覧に戻る
            </Link>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-flag-line text-4xl"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">目標設定理論</h1>
            <p className="text-xl text-white/90">Goal-Setting Theory</p>
            <p className="text-lg text-white/80 mt-2">提唱者：Locke & Latham</p>
          </div>
        </div>
      </section>

      {/* Core Message */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-green-500 to-emerald-500 rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-3xl font-bold mb-4">明確性・到達可能性・フィードバックが揃って初めて目標は機能する</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            {/* 機能する目標の3条件 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-green-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-focus-3-line text-xl text-white"></i>
                </div>
                機能する目標の3条件
              </h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-focus-2-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">明確性</h3>
                  <p className="text-sm text-gray-600">Clarity</p>
                  <p className="text-gray-700 text-sm leading-relaxed mt-3">
                    何を達成すべきか、具体的で測定可能な形で定義されている
                  </p>
                </div>
                <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 border border-emerald-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-route-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">到達可能性</h3>
                  <p className="text-sm text-gray-600">Achievability</p>
                  <p className="text-gray-700 text-sm leading-relaxed mt-3">
                    挑戦的だが、努力すれば達成できる現実的な目標である
                  </p>
                </div>
                <div className="bg-gradient-to-br from-teal-50 to-green-50 rounded-xl p-6 border border-teal-200">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-chat-check-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">フィードバック</h3>
                  <p className="text-sm text-gray-600">Feedback</p>
                  <p className="text-gray-700 text-sm leading-relaxed mt-3">
                    進捗状況が定期的に確認でき、軌道修正ができる
                  </p>
                </div>
              </div>
            </div>

            {/* 薬局運営への活用 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-green-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-green-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-hospital-line text-xl text-white"></i>
                </div>
                薬局運営への活用
              </h2>
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-emotion-sad-line text-green-600 mr-2"></i>
                    KPI疲れの原因分析
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    「KPI疲れ」が起きている場合、3条件のどれかが欠けている可能性があります。
                  </p>
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="bg-white rounded-lg p-4 border border-green-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm">明確性の欠如</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・目標が曖昧</li>
                        <li>・何をすればいいか不明</li>
                        <li>・優先順位が不明確</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-emerald-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm">到達可能性の欠如</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・目標が高すぎる</li>
                        <li>・リソースが不足</li>
                        <li>・外部要因で達成困難</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-teal-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm">フィードバックの欠如</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・進捗が見えない</li>
                        <li>・結果しか評価されない</li>
                        <li>・軌道修正の機会がない</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 border border-emerald-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-stack-line text-emerald-600 mr-2"></i>
                    行動目標＋結果目標のセット設計
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    結果目標だけでなく、行動目標もセットで設定することで、目標の機能性が高まります。
                  </p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white rounded-lg p-4 border border-emerald-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm flex items-center">
                        <i className="ri-flag-line text-emerald-500 mr-2"></i>
                        結果目標（例）
                      </h4>
                      <p className="text-sm text-gray-600">
                        「かかりつけ薬剤師指導料の算定件数を月20件にする」
                      </p>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-teal-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm flex items-center">
                        <i className="ri-walk-line text-teal-500 mr-2"></i>
                        行動目標（例）
                      </h4>
                      <p className="text-sm text-gray-600">
                        「毎日3人の患者さんにかかりつけ薬剤師の説明をする」
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 p-3 bg-green-100 rounded-lg">
                    <p className="text-sm text-green-700">
                      <strong>ポイント：</strong>行動目標は自分でコントロールできるため、達成感を得やすく、モチベーション維持につながる
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 目標設定のチェックリスト */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-green-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-checkbox-multiple-line text-xl text-white"></i>
                </div>
                目標設定のチェックリスト
              </h2>
              <div className="space-y-4">
                <div className="flex items-start p-4 bg-green-50 rounded-lg border border-green-200">
                  <i className="ri-checkbox-blank-circle-line text-green-500 mr-3 mt-1"></i>
                  <span className="text-gray-700">目標は具体的で測定可能か？（数値化できているか？）</span>
                </div>
                <div className="flex items-start p-4 bg-emerald-50 rounded-lg border border-emerald-200">
                  <i className="ri-checkbox-blank-circle-line text-emerald-500 mr-3 mt-1"></i>
                  <span className="text-gray-700">目標は挑戦的だが、達成可能な範囲か？</span>
                </div>
                <div className="flex items-start p-4 bg-teal-50 rounded-lg border border-teal-200">
                  <i className="ri-checkbox-blank-circle-line text-teal-500 mr-3 mt-1"></i>
                  <span className="text-gray-700">進捗を確認する仕組みがあるか？（週次・月次など）</span>
                </div>
                <div className="flex items-start p-4 bg-green-50 rounded-lg border border-green-200">
                  <i className="ri-checkbox-blank-circle-line text-green-500 mr-3 mt-1"></i>
                  <span className="text-gray-700">結果目標だけでなく、行動目標も設定しているか？</span>
                </div>
                <div className="flex items-start p-4 bg-emerald-50 rounded-lg border border-emerald-200">
                  <i className="ri-checkbox-blank-circle-line text-emerald-500 mr-3 mt-1"></i>
                  <span className="text-gray-700">目標の意味・目的を職員と共有しているか？</span>
                </div>
              </div>
            </div>

            {/* 明日の一手 */}
            <div className="bg-gradient-to-br from-green-600 via-emerald-600 to-teal-600 rounded-2xl shadow-2xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-4 flex items-center">
                <i className="ri-calendar-check-line text-3xl mr-3"></i>
                明日の一手
              </h2>
              <p className="text-lg text-white/90 leading-relaxed mb-6">
                現在の目標が「明確性・到達可能性・フィードバック」の3条件を満たしているか確認しましょう。
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6">
                <p className="text-white font-semibold mb-2">具体的なアクション：</p>
                <p className="text-white/90 leading-relaxed">
                  職員に「今の目標は達成できそうですか？」「何があれば達成しやすくなりますか？」と問いかけ、目標の妥当性を確認する。
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-8 border-t border-gray-200">
              <Link to="/motivation/intrinsic-extrinsic" className="flex items-center text-green-600 hover:text-green-700 font-semibold transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                内発的／外発的動機づけ
              </Link>
              <Link to="/motivation/reinforcement" className="flex items-center text-green-600 hover:text-green-700 font-semibold transition-colors">
                強化理論
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
